/**
 * Frontend API Service for Franchise Info Requests
 * Handles API calls to submit franchise information requests
 */

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL!;

export interface FranchiseFormData {
  firstName: string;
  lastName: string;
  email: string;
  streetAddress: string;
  city: string;
  state: string;
  netWorth: string;
  availableCash: string;
  desiredLocation: string;
  phone: string;
  availability: string;
  referral: string;
}

export interface FranchiseSubmitResponse {
  success: boolean;
  message: string;
  documentId?: string;
}

/**
 * Submit franchise info request to backend
 */
export const submitFranchiseRequest = async (
  data: FranchiseFormData
): Promise<FranchiseSubmitResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/franchise/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        timestamp: new Date().toISOString(),
      }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || result.error || `HTTP ${response.status}`);
    }

    return result;
  } catch (error) {
    throw error;
  }
};
